import { Icons } from '@pankod/refine-antd';
import { SyncContent } from './SyncContent';

export const sync = {
  name: 'sync',
  icon: <Icons.HomeOutlined />,
  list: SyncContent
};
